import React, { useState } from 'react';
import "../styles/footer.css"
import waves from "../assets/images/waves.webp";
import { FaInstagram, FaFacebookF, FaPinterestP } from "react-icons/fa";
import { SiTiktok } from "react-icons/si"; 
import axios from '../api/axiosInstance';
import { ToastContainer, toast } from 'react-toastify';

const Footer = () => {
 const [email, setEmail] = useState('');
 
  const handleSignUpClick = async () => {
    console.log("clicked");
    if (!email.trim()) {
      toast.warning("Please enter a valid email address.");
      return;
    }

    try {
      const response = await axios.post('https://your-api-endpoint.com/signup', {
        email: email
      });

      toast.success("Thanks for signing up!");
      setEmail('');
    } catch (error) {
      toast.error("Something went wrong. Please try again later.");
      console.error('Error submitting email:', error);
    }
  };


  return (
    <>
    <div className="footer">
    <div className="footerTopContainer">
        <div className="list-containers">
            <div className="leftSideLinks">
                <ul className='LEFT-UL'>
                    <li><a href="">FAQ</a></li>
                    <li><a href="">ABOUT</a></li>
                    <li><a href="">SHIPPING AND RETURNS</a></li>
                    <li><a href="">TERMS OF SERVICE</a></li>
                    <li><a href="">LOGIN</a></li>
                    <li><a href="">BLOG</a></li>
                    <li><a href="">JOIN FAMILY</a></li>
                </ul>
                </div>
                <div className="rightSideLinks">
                <ul className='RIGHT-UL'>
                    <li><a href="">PRIVACY POLICY</a></li>
                    <li><a href="">CAREERS</a></li>
                    <li><a href="">PRESS AND PARTNERSHIP</a></li>
                    <li><a href="">MANAGE PERSONAL INFO</a></li>
                    <li><a href="">CONTACT</a></li>
                </ul>
            </div>

        
        </div>
        </div>
       <div className="footerBottomContainer">
  <span>STAY IN TOUCH</span>

  <div className="inputTermsWrapper">
    <div className="emailInput">
      <input type="email" placeholder="EMAIL ADDRESS" />
      <button  onClick={handleSignUpClick}>SIGN UP</button>
    </div>

    <div className="terms">
      <span>
        By providing my email address I agree that I have reviewed and agree to
        the Terms of Service and Privacy Policy.
      </span>
    </div>
  </div>
</div>
<div className="waves">
    <img src={waves} alt="waves" />
</div>
<div className="social-icons">
  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
    <FaInstagram className="icon instagram" />
  </a>
  <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer">
    <SiTiktok className="icon tiktok" />
  </a>
  <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer">
    <FaPinterestP className="icon pinterest" />
  </a>
  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
    <FaFacebookF className="icon facebook" />
  </a>
</div>
<div className="allServicesareup">
  <center>
    <div className="uptime-badge-wrapper">
  <iframe
  src="https://boonzie.betteruptime.com/badge?theme=light"
  width="250"
  height="30"
  frameBorder="0"
  scrolling="no"
  style={{  border: "none",margin:'1rem',zIndex:'100' }}
  title="uptime-badge"
/>
</div>
</center>
</div>
    </div>
    </>
  )
}

export default Footer